import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2024 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin O
 * @contact hjoh@detech.co.kr
 * @date 2024-03-04
 * @brief SEI 사용자 메일 인증 - 고도화 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useRecoilValue } from "recoil";
// design
import "/static/css/login.css";
// recoil
import { getApiLangState } from "../../../recoil/langState";
// utils
import { useLocation, useNavigate } from "react-router-dom";
import * as HttpUtil from "../../../utils/api/HttpUtil";
import * as CONST from "../../../utils/Const";
import LandingLoginPop from "../../common/popup/LandingLoginPop";
import NoEhpCertification from "./NoEhpCertification";
import OkEhpCertification from "./OkEhpCertification";
function EhpCertification() {
    // recoil
    const apiLang = useRecoilValue(getApiLangState);
    const [ok, setOk] = useState("");
    // params
    const location = useLocation();
    // params - search
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate();
    let email = params.get(CONST.STR_EMAIL);
    let key = params.get(CONST.STR_KEY);
    const { data: data, run } = useAsync({
        promiseFn: HttpUtil.PromiseHttp,
        httpMethod: "POST",
        appPath: "/auth/key/valid",
        appQuery: {
            userId: email,
            token: key,
            language: apiLang,
        },
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setOk("ok");
            }
            else {
                localStorage.setItem(CONST.STR_EMAIL, email);
                setOk("no");
                /*    if (data.errorList.filter((err) => err.field == "userId")) {
                     alert(data.errorList.map((err) => err.msg));
                     navigate(CONST.URL_LOGIN);
                   } else {
                     setOk("no");
                   } */
            }
        }
    }, [data]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ id: "login", className: "login type2" }, { children: [_jsxs("div", Object.assign({ className: "login__left" }, { children: [_jsx("div", Object.assign({ className: "left__top" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "LS" })) })), _jsxs("div", Object.assign({ className: "left__center" }, { children: [_jsx("p", { children: "Welcome to LS ELECTRIC" }), _jsx("h1", { children: _jsx("img", { src: require("/static/img/logo_login_title_beyondx.svg"), alt: "BeyondXEnable" }) })] })), _jsx("p", Object.assign({ className: "left__bottom" }, { children: "LS ELECTRIC \u00A9" }))] })), ok == "" && (_jsxs("div", Object.assign({ className: "login__right webmailok" }, { children: [_jsx("h2", { children: _jsx("p", Object.assign({ className: "tit" }, { children: "\uC778\uC99D \uC911\uC785\uB2C8\uB2E4" })) }), _jsx("div", Object.assign({ className: "login__form" }, { children: _jsx("form", { action: "#", method: "", name: "loginform" }) }))] }))), ok == "ok" && _jsx(OkEhpCertification, {}), ok == "no" && _jsx(NoEhpCertification, {})] })), _jsx(LandingLoginPop, {}), _jsx("div", { className: "dimm" })] }));
}
export default EhpCertification;
